const AgeOfTheFranks = {
  id: '8',
  name: 'Age of the Franks'
};

export default AgeOfTheFranks;
